/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var GearType;
(function (GearType) {
    GearType["Automatic"] = "Automatic";
    GearType["Manual"] = "Manual";
    GearType["SemiAutomatic"] = "SemiAutomatic";
})(GearType || (GearType = {}));
export function GearTypeFromJSON(json) {
    return GearTypeFromJSONTyped(json, false);
}
export function GearTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function GearTypeToJSON(value) {
    return value;
}
